import { render, staticRenderFns } from "./PermissionDenied.vue?vue&type=template&id=51b2ca75"
var script = {}
import style0 from "./PermissionDenied.vue?vue&type=style&index=0&id=51b2ca75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports